/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_InactiveInputs */

const vi_customer_inactive = /** @type {(inputs: Customer_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng`)
};

/**

* @param {Customer_InactiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_inactive = /** @type {((inputs?: Customer_InactiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_InactiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_inactive(inputs)
});